import p_nav_previous from '../../Assets/Images/p_nav_previous.svg';
import p_dummyImage from '../../Assets/Images/p_dummyImage.svg';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { addUserFamilyMember, addUserPet, deleteFamilyMember, deleteUserPet, getPetTypes, uploadFamilyMemberImage, uploadPetImage, userSingleFamilyMemberDetail, userSinglePetDetail, userUpdateSinglePetDetail } from '../../Services/api';
import p_nav_edit from '../../Assets/Images/p_nav_edit.svg';
import p_options_vertical from '../../Assets/Images/p_options_vertical.svg';
import ImageCropperModal from '../../Components/modal/imageCropperModal';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';


const PetRegister = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const { frompage, vendorId, AddPage } = location.state || {};
    const [isLoading, setLoadingStatus] = useState(false);
    const [profilePhoto, setProfilePhoto] = useState(p_dummyImage);
    const [profilePhotoName, setProfilePhotoName] = useState('');
    const [value, setValue] = useState('');
    const fileRef = useRef(null);
    const [petTypes, setPetTypes] = useState([]);
    const [vendorid, setVendorid] = useState('')
    const [formData, setFormData] = useState({
        "name": "",
        "type": "",
        "type_id": "",
        "breed": "",
        "gender": "",
        "age": "",
        "temperament": "",
        "about": "",
        "weight": "",
        "pet_id": "",
        "pet_image": ""
    });
    const [isImageCropperModaOpen, setIsImageCropperModaOpen] = useState(false);
    const [imageToCrop, setImageToCrop] = useState('');
    const [modalOpen, setModalOpen] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false)
    const listItems = Array(5).fill(null); // repeat 5 times
    const [pageLoaded, setPageLoaded] = useState(false)

    useEffect(() => {
        setTimeout(() => {
            setPageLoaded(true)

        }, 1000);
    }, [frompage])

    useEffect(() => {

        getPetTypes().then((res) => {
            setPetTypes(res.data?.result);
        });

        if (location.state && location.state?.pet_id) {
            userSinglePetDetail(location.state).then((res) => {
                setFormData({
                    name: res.data?.pet_detail?.name,
                    type: res.data?.pet_detail?.type_id,
                    breed: res.data?.pet_detail?.breed,
                    gender: res.data?.pet_detail?.gender,
                    age: res.data?.pet_detail?.age,
                    temperament: res.data?.pet_detail?.temperament,
                    about: res.data?.pet_detail?.about,
                    weight: res.data?.pet_detail?.weight,
                    pet_id: res.data?.pet_detail?.pet_id,
                    pet_image: res.data?.pet_detail?.pet_image_name
                });
                setProfilePhoto(res.data?.pet_detail?.pet_image)
            });
        }
    }, [value]);

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
    };

    const dispErrorMsg = (msg) => {
        toast(msg, {
            position: "bottom-center",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            className: 'text-danger toast-style-1'
        });
    }

    const handleFileRead = async (event) => {
        const file = event.target.files[0]
        const base64 = await convertBase64(file);

        if (base64) {
            setImageToCrop(base64);
            setIsImageCropperModaOpen(true);
        }

    }
    useEffect(() => {
        let localServiceDetail = localStorage.getItem("serviceDetail") ? JSON.parse(localStorage.getItem("serviceDetail")) : "";
        setVendorid(localServiceDetail.vendorId);

    }, [])

    const onImageCropped = (e) => {

        if (e) {
            let body = {
                "pet_image": e
            }
            uploadPetImage(body)
                .then((res) => {

                    if (res.data.status === "1") {
                        setProfilePhoto(res.data.results);
                        setProfilePhotoName(res.data.img_name);
                        setFormData(prevData => ({
                            ...prevData,
                            pet_image: res.data.img_name
                        }));

                        setIsImageCropperModaOpen(false);
                    }
                    setLoadingStatus(false);

                })
                .catch((error) => {
                    setLoadingStatus(false)
                    toast(error.message, {
                        position: "bottom-center",
                        autoClose: 5000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                        className: 'text-danger toast-style-1'
                    });
                });
            clearFileInput();
        }
    }

    const convertBase64 = (file) => {

        if (file) {
            return new Promise((resolve, reject) => {
                const fileReader = new FileReader();
                fileReader.readAsDataURL(file)
                fileReader.onload = () => {
                    resolve(fileReader.result);
                }
                fileReader.onerror = (error) => {
                    reject('custom error', error);
                }
            })
        }
    }

    const handleSubmit = (event) => {
        event.preventDefault();


        if (formData.name == '') {
            dispErrorMsg('Pet name is required')
            return
        }
        else if (formData.type == '') {
            dispErrorMsg('Pet type is required')
            return
        }
        else if (formData.gender == '') {
            dispErrorMsg(' Gender is required')
            return
        }
        else if (formData.temperament == '') {
            dispErrorMsg('Pet Temperament is required')
            return
        }
        else if (formData.age == '') {
            dispErrorMsg(' Age is required')
            return
        }
        else if (formData.breed == '') {
            dispErrorMsg('Breed is required')
            return
        }
        else if (formData.weight == '') {
            dispErrorMsg(' Weightp is required')
            return
        }
        else if (formData.about == '') {
            dispErrorMsg('About pet is required')
            return
        }

        setLoadingStatus(true);
        if (formData.pet_id != '') {
            userUpdateSinglePetDetail(formData)
                .then((res) => {
                    setLoadingStatus(false);

                    if (res.data?.status === '1') {
                        navigate('/profile', { state: { divRef: 'myPets' } })
                    }

                })
                .catch((error) => {
                    setLoadingStatus(false)
                    toast(error.message, {
                        position: "bottom-center",
                        autoClose: 5000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                        className: 'text-danger toast-style-1'
                    });
                });
        } else {
            addUserPet(formData)
                .then((res) => {
                    setLoadingStatus(false);

                    if (res.data?.status === '1') {
                        if (AddPage == "pet") {
                            navigate(`/door-step-service/${vendorId}`, { state: {} })
                        }
                        else {
                            navigate('/profile', { state: { divRef: 'myPets' } })
                        }
                    }

                })
                .catch((error) => {
                    setLoadingStatus(false)
                    toast(error.message, {
                        position: "bottom-center",
                        autoClose: 5000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                        className: 'text-danger toast-style-1'
                    });
                });
        }

    }

    const deletePet = () => {
        deleteUserPet(location.state).then((res) => {

            if (res.data?.status === '1') {
                navigate('/profile', { state: { divRef: 'myPets' } })
            }
        })
    }

    const clearFileInput = () => {
        if (fileRef.current) {
            fileRef.current.value = null;
        }
    };
    const openModal = () => {
        setModalOpen(true);
        setIsModalOpen(true)
        setIsOpen(false)
    };

    const closeModal = () => {
        setModalOpen(false);
        setIsModalOpen(false)
    };
    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };
    return (
        <>
            <div className="d-flex justify-content-between align-items-center p-3 p-navbar bg-white">
                <div className="d-flex justify-content-between align-items-center ms-2 me-2">
                    <img src={p_nav_previous} width={'24px'} height={'16px'} alt='Previous Button' role='button' onClick={() => {
                        if (frompage == "ServiceBookingFlow") {
                            navigate(`/door-step-service/${vendorid}`, { state: { AddPage: 'pet' } })
                        }
                        else {
                            navigate('/profile', { state: { divRef: 'myPets' } })
                        }
                    }
                        // navigate('/profile', { state: { divRef: 'myPets' } })
                    }
                    />
                    <div className='ff-balooPaaji2-bold fs-20 ms-2 ps-1'>
                        {
                            formData?.pet_id
                                ?
                                <span>Pet Profile Edit</span>
                                :
                                <span>Pet Register </span>
                        }
                    </div>
                </div>

                {
                    formData?.pet_id &&
                    <div className="profileEdit position-relative">

                        <img src={p_options_vertical} width="27px" height="27px" role="button" onClick={toggleDropdown} alt="Profile Options" />
                        {isOpen && (

                            <ul className="delete_dropdown position-top-end primary-bg p-0 rounded-3" aria-labelledby="profile-options"
                                style={{ display: isOpen ? 'block' : 'none', }} onClick={() => openModal()}>
                                <li className='delete_dropdown_ul '>
                                    <span className="delete_dropdown-item ms-2  text-light ff-poppins-bold fs-12" role="button">Delete</span>
                                </li>
                            </ul>

                        )}
                    </div>
                }
            </div>
            {
                pageLoaded
                    ?

                    <div className='formPage scroller-style-y' >
                        <div className='text-center'>
                            <img className='bg-white rounded-3' src={profilePhoto} width={'110px'} height={'110px'} alt='Default image' />
                            <div className='d-flex justify-content-center'>
                                <input className='d-none' type='file' accept="image/*" onChange={handleFileRead} ref={fileRef} />
                                <div className='addPhotoBtn d-flex justify-content-center align-items-center primary-bg text-white ff-poppins-regular fs-16 fw-600' role='button' onClick={() => { fileRef.current?.click() }}>Add Photo</div>
                            </div>
                        </div>

                        <form onSubmit={handleSubmit}>
                            {/* Pet Name  */}
                            <input type='text' className='mb-3 ps-3 pe-3 pt-0 pb-0 w-100 ff-poppins-regular fs-16 bg-white text-dark' placeholder='Pet Name' name="name" value={formData.name} maxLength={20} onChange={handleChange} />

                            {/* Pet Type  */}
                            <select className={`form-select border-0 ff-poppins-regular fs-16 mb-3  ${formData.type === '' ? 'placeholder-style' : ''}`} aria-label="Default select example" name="type" value={formData.type} onChange={handleChange} >
                                <option value='' selected disabled>Pet Type</option>
                                <option value='1'>Dog</option>
                                <option value='2'>Cat</option>
                            </select>

                            {/* Pet Gender */}
                            <select className={`form-select border-0 ff-poppins-regular fs-16 mb-3  ${formData.gender === '' ? 'placeholder-style' : ''}`} aria-label="Default select example" name="gender" value={formData.gender} onChange={handleChange} >
                                <option value='' selected disabled>Pet Gender</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                            </select>

                            {/* Pet Temperament */}
                            <select className={`form-select border-0 ff-poppins-regular fs-16 mb-3  ${formData.temperament === '' ? 'placeholder-style' : ''}`} aria-label="Default select example" name="temperament" value={formData.temperament} onChange={handleChange} >
                                <option value='' selected disabled>Pet Temperament</option>
                                <option value="Friendly">Friendly</option>
                                <option value="Aggressive">Aggressive</option>
                                <option value="Calm">Calm</option>
                                <option value="Neutral">Neutral</option>
                                <option value="Other">Other</option>
                            </select>

                            {/* Pet Age  */}
                            <input
                                type="text"
                                inputMode="numeric"
                                className="mb-3 ps-3 pe-3 pt-0 pb-0 w-100 ff-poppins-regular fs-16 bg-white text-dark"
                                placeholder="Age"
                                name="age"
                                value={formData.age}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^\d{0,2}$/.test(value)) {
                                        handleChange(e);
                                    }
                                }}
                                maxLength={2}
                            />


                            {/* Breed  */}
                            <input type='text' className='mb-3 ps-3 pe-3 pt-0 pb-0 w-100 ff-poppins-regular fs-16 bg-white text-dark' placeholder='Breed' name="breed" value={formData.breed} onChange={handleChange} maxLength={30} />

                            {/* Pet Weight  */}
                            <input type='number' inputMode="numeric" className='mb-3 ps-3 pe-3 pt-0 pb-0 w-100 ff-poppins-regular fs-16 bg-white text-dark' placeholder='Weight' name="weight" value={formData.weight}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^\d{0,3}$/.test(value)) {
                                        handleChange(e);
                                    }
                                }}
                                maxLength={3} />

                            {/* About Them  */}
                            <textarea className='w-100 border-0 ff-poppins-regular fs-16 custom-input' rows={5} placeholder="About Pet" name="about" maxLength={120} value={formData.about} onChange={handleChange}></textarea>
                            <div className='d-flex justify-content-end ff-poppins-regular mt-1 mb-3 fs-14'>{formData.about.length} / 120</div>

                            <div className='d-flex justify-content-center'>
                                <button className='submitBtn d-flex justify-content-center align-items-center primary-bg ff-poppins-regular fs-16 fw-600 text-white border-0'>
                                    {formData.pet_id != '' ? 'UPDATE' : 'ADD'} PET
                                </button>
                            </div>
                        </form>
                    </div>

                    :
                    <div style={{ padding: "20px", backgroundColor: 'rgb(77 77 77 / 7%)' }}>
                        <div style={{ display: "flex", justifyContent: "center", margin: "20px 0" }}>
                            <div className='text-center'>
                                <div className='mb-3'>
                                    <Skeleton height={120} width={120} borderRadius={12} />
                                </div>
                                <Skeleton height={50} width={200} borderRadius={12} />
                            </div>
                        </div>
                        <div className='mb-5'>
                            {listItems.map((_, index) => (
                                <div className='mt-3'>
                                    <Skeleton height={50} width={350} borderRadius={12} />
                                </div>
                            ))}
                        </div>
                    </div>
            }

            {/* Delete Modal  */}
            {
                modalOpen &&


                <div className={`modal show d-flex justify-content-center  ${modalOpen ? "show" : ""}`} tabIndex="-1" style={{ display: "block" }}>
                    <div className="modal-dialog-centered loginWarningDialog" style={{ maxWidth: "360px" }}>
                        <div className="modal-content">
                            <div className="modal-body">

                                <div className="ff-poppins-medium fs-13 text-center mt-2">
                                    Are you sure you want to delete this pet ?
                                </div>
                                <div className="d-flex justify-content-evenly mt-3" role="button" >
                                    <div className="loginBtn text-light  primary-bg "
                                        onClick={() => deletePet()}>
                                        Delete
                                    </div>

                                    <div className="loginBtn  primary-text primary-bg-light" onClick={() => closeModal()}>
                                        Cancel
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                // <div class={`modal   d-flex align-items-center`} tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                //     <div class="modal-dialog modal-sm">
                //         <div class="modal-content">
                //             <div class="modal-body ps-5 pe-5 pt-4 pb-4">
                //                 <div className='text-center'>Are you sure you want to delete this Pet ?</div>

                //                 <div className='d-flex justify-content-between mt-3'>
                //                     <button type="button" class="btn btn-secondary" onClick={() => closeModal()}>Cancel</button>
                //                     <button type="button" class="btn btn-danger" onClick={() => deletePet()} data-bs-dismiss="modal">Delete</button>
                //                 </div>
                //             </div>
                //         </div>
                //     </div>
                // </div>
            }

            <ImageCropperModal
                isOpen={isImageCropperModaOpen}
                inputImage={imageToCrop}
                onSelect={onImageCropped}
                onCancel={() => {
                    setIsImageCropperModaOpen(false);
                    clearFileInput();
                }}
            />
            {isModalOpen && <div className="modal-backdrop fade show"></div>}

        </>
    )
}

export default PetRegister;